// extracted by mini-css-extract-plugin
export default {"container":"IC-z"};